"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createFilter", {
  enumerable: true,
  get: function get() {
    return _reactSelect.createFilter;
  }
});
exports.default = exports.SelectInner = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _warning = _interopRequireDefault(require("warning"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _reactI18n = require("@insolus/react-i18n");

var _types = require("./_types");

var _components = _interopRequireDefault(require("./components"));

var _utils = require("./_utils");

var Select = function Select(props, ref) {
  var _useTranslate = (0, _reactI18n.useTranslate)('ui-kit'),
      __ = _useTranslate.__;

  var options = props.options,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$hideSelectedOp = props.hideSelectedOptions,
      hideSelectedOptions = _props$hideSelectedOp === void 0 ? false : _props$hideSelectedOp,
      _props$menuPlacement = props.menuPlacement,
      menuPlacement = _props$menuPlacement === void 0 ? 'auto' : _props$menuPlacement,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$filterOption = props.filterOption,
      filterOption = _props$filterOption === void 0 ? _utils.defaultOptionFilter : _props$filterOption,
      noResultsText = props.noResultsText,
      loadingMessage = props.loadingMessage,
      tabIndex = props.tabIndex,
      onChange = props.onChange,
      onInputChange = props.onInputChange,
      valueRenderer = props.valueRenderer,
      optionRenderer = props.optionRenderer,
      groupRenderer = props.groupRenderer;
  (0, _warning.default)(multiple || !Array.isArray(props.defaultValue) && !Array.isArray(props.value), "Vous ne devriez pas passer plusieurs valeurs (`defaultValue` ou `value`) " + "\xE0 un `<Select>` non multiple.");

  var _options = React.useMemo(function () {
    return (0, _utils.normalizeOptions)(options);
  }, [options]);

  var _getObjectValue = React.useCallback(function (value) {
    if (value == null) {
      return value;
    }

    if (typeof value === 'number' || typeof value === 'string') {
      var _options$find;

      return (_options$find = _options.find(function (option) {
        return option.value == value;
      })) !== null && _options$find !== void 0 ? _options$find : null;
    }

    return value.reduce(function (acc, _value) {
      var objectValue = _options.filter(function (option) {
        return option.value == _value;
      });

      return objectValue ? acc.concat(objectValue) : acc;
    }, []);
  }, [_options]);

  var handleInputChange = React.useCallback(function (value, meta) {
    if (onInputChange) {
      onInputChange(value, meta.action);
    }
  }, [onInputChange]);
  var handleChange = React.useCallback(function (objectValue, meta) {
    var _getValue = function _getValue(value) {
      if (value == null) {
        return null;
      }

      if (multiple) {
        var _values = !Array.isArray(value) ? [value] : value;

        return _values.map(function (_value) {
          return _value.value;
        });
      }

      var _value = Array.isArray(value) ? value[0] : value;

      return _value.value;
    };

    var value = _getValue(objectValue);

    if (onChange) {
      onChange(value, meta.action);
    }
  }, [onChange, multiple]);
  var formatOptionLabel = React.useCallback(function (option, meta) {
    switch (meta.context) {
      case 'menu':
        if (optionRenderer) {
          var _searchValue = meta.inputValue === '' ? null : meta.inputValue;

          return optionRenderer(option._original, _searchValue);
        }

        break;

      case 'value':
        if (valueRenderer) {
          return valueRenderer(option._original);
        }

        break;
    }

    return option.label;
  }, [valueRenderer, optionRenderer]);
  var formatGroupLabel = React.useCallback(function (group) {
    if (groupRenderer) {
      return groupRenderer(group._original);
    }

    return group.label;
  }, [groupRenderer]);
  var loadingMessageRenderer = React.useCallback(function () {
    return loadingMessage !== null && loadingMessage !== void 0 ? loadingMessage : __('select.loading');
  }, [__, loadingMessage]);
  var noResultsTextRenderer = React.useCallback(function (_ref) {
    var inputValue = _ref.inputValue;

    if (!noResultsText) {
      return __('select.no-results');
    }

    if (typeof noResultsText === 'function') {
      return noResultsText(inputValue);
    }

    return noResultsText;
  }, [__, noResultsText]);
  var screenReaderStatus = React.useCallback(function (_ref2) {
    var count = _ref2.count;
    return __('select.screen-reader-status', {
      count: count
    });
  }, [__]);
  var placeholder = props.placeholder;

  if (!placeholder) {
    placeholder = !searchable ? __('select.select') : __('select.select-or-start-typing');
  }

  var _className = (0, _classnames.default)('Select', className);

  var _tabIndex = tabIndex ? tabIndex.toString() : undefined;

  return React.createElement(_reactSelect.default, {
    ref: ref,
    id: props.id,
    name: props.name,
    className: _className,
    classNamePrefix: "Select",
    options: _options,
    defaultValue: _getObjectValue(props.defaultValue),
    value: _getObjectValue(props.value),
    inputValue: props.inputValue,
    menuIsOpen: props.open,
    isMulti: multiple,
    isDisabled: disabled,
    isLoading: loading,
    placeholder: placeholder,
    isSearchable: searchable,
    isClearable: clearable,
    hideSelectedOptions: hideSelectedOptions,
    autoFocus: autoFocus,
    onChange: handleChange,
    onInputChange: handleInputChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onMenuOpen: props.onOpen,
    onMenuClose: props.onClose,
    tabIndex: _tabIndex,
    filterOption: filterOption,
    noOptionsMessage: noResultsTextRenderer,
    loadingMessage: loadingMessageRenderer,
    formatOptionLabel: formatOptionLabel,
    menuPlacement: menuPlacement,
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby'],
    screenReaderStatus: screenReaderStatus,
    components: _components.default,
    formatGroupLabel: formatGroupLabel
  });
};

exports.SelectInner = Select;

var _Select = React.forwardRef(Select);

_Select.isFormControl = true;
_Select.propTypes = {
  'name': _propTypes.default.string,
  'options': _types.OPTIONS_TYPE,
  'defaultValue': _propTypes.default.oneOfType([_types.VALUE_TYPE, _propTypes.default.arrayOf(_types.VALUE_TYPE)]),
  'value': _propTypes.default.oneOfType([_types.VALUE_TYPE, _propTypes.default.arrayOf(_types.VALUE_TYPE)]),
  'inputValue': _propTypes.default.string,
  'placeholder': _propTypes.default.string,
  'multiple': _propTypes.default.bool,
  'disabled': _propTypes.default.bool,
  'open': _propTypes.default.bool,
  'loading': _propTypes.default.bool,
  'noResultsText': _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  'loadingMessage': _propTypes.default.string,
  'searchable': _propTypes.default.bool,
  'hideSelectedOptions': _propTypes.default.bool,
  'clearable': _propTypes.default.bool,
  'autoFocus': _propTypes.default.bool,
  'onChange': _propTypes.default.func,
  'onInputChange': _propTypes.default.func,
  'onFocus': _propTypes.default.func,
  'onBlur': _propTypes.default.func,
  'onOpen': _propTypes.default.func,
  'onClose': _propTypes.default.func,
  'optionRenderer': _propTypes.default.func,
  'valueRenderer': _propTypes.default.func,
  'groupRenderer': _propTypes.default.func,
  'id': _propTypes.default.string,
  'className': _propTypes.default.string,
  'tabIndex': _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  'menuPlacement': _propTypes.default.oneOf(['auto', 'top', 'bottom']),
  'filterOption': _propTypes.default.func
};
var _default = _Select;
exports.default = _default;